import { useNavigate } from "react-router";
import { Form, Formik, FormikHelpers } from "formik";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useCallback } from "react";
import * as yup from "yup";
import {useAddDashboard} from "./data";
import FormActions from "../../components/dialog/FormActions";
import DashboardAddFormContent from "./DashboardAddFormContent";

export type Props = {
  onClose?: () => void;
};

const schema = yup
  .object({
    label: yup.string().required().min(1).max(255),
  })
  .required();

export type FormValues = yup.InferType<typeof schema>;

const initialValues: FormValues = {
  label: "",
};
export default function DashboardAddForm({ onClose }: Props) {
  const { mutateAsync } = useAddDashboard();
  const navigate = useNavigate();
  const onSubmit = useCallback(
    async (
      { label }: FormValues,
      { setSubmitting, setStatus }: FormikHelpers<FormValues>
    ) => {
      setStatus(undefined);
      try {
        await mutateAsync({
          label: label,
        });
        navigate(`/dashboard-list`);
        onClose?.();
      } catch (error: any) {
        setStatus(error.message);
      } finally {
        setSubmitting(false);
      }
    },
    [mutateAsync, navigate, onClose]
  );
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      <>
        <DialogContent>
          <Form id="dashboard-erstellen" noValidate>
            <DashboardAddFormContent />
          </Form>
        </DialogContent>
        <DialogActions>
          <FormActions form="dashboard-erstellen" onClose={onClose} />
        </DialogActions>
      </>
    </Formik>
  );
}
